import React from 'react';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import * as Icons from '@fortawesome/fontawesome-free-solid';


const Slot = ({
  slot: {
    time, status, type, fs,
  },
  nextSlot,
  nextSlotClicked,
  bookedOverlap,
  incompleteBlock,
  spotOn,
  spotOnMatch,
  drawSpotOn,
  hoverActive,
  clicked,
  isLastHover,
  isBetweenHover,
  isLastClick,
  isBetweenClick,
  onClick,
  isOccupied,
  placementChecker,
    showMaster,
                informationBetween,
    productName,

}) => {
  if (status === 'closed') {
    return <div className="closed">-</div>;
  }

  if (status === 'booked') {
    return <div className="booked">{time}</div>;
  }

  if (status === 'passed') {
    return <div className="passed">{time}</div>;
  }

  if (status === 'foresight') {
    return <div className="foresight">{time}</div>;
  }

  if (type === 'endOfDay') {
    return <div className="closed">-</div>;
  }
  if (placementChecker) {
    const styles = { background: 'orange', color: 'white' };
    return (<div style={styles}>
      <FontAwesomeIcon
        icon="arrow-down"
        size="1x"
      />

      <FontAwesomeIcon
        icon="arrow-up"
        size="1x"
      />

            </div>);
  }

  /*
    if(status === 'divider') {
        return <div className="divider">{time}</div>;

    }

*/


  const checkOverlapAndIncomplete = bookedOverlap === false && incompleteBlock === false;

  const bookable = checkOverlapAndIncomplete || spotOnMatch;


  let className = '';

  let borderClass = '';

  if (type === 'first') {
    borderClass = 'border-top';
  } else if (type === 'last') {
    borderClass = 'border-bottom';
  }

  if (bookable) {
    className = '';
  }

  let displayText = time;
  if (type === 'occupied') {
    className = 'occupied';
  }
  if (type === 'occupied' && hoverActive) {
    displayText = 'Upptagen';
  }
  if (bookable) {
    if (hoverActive) {
      className = 'hover';
    }
  }
  if (clicked) {
    className = 'active';
    if (isBetweenClick) {
      displayText = '-';
    }

    if (isLastClick) {
      displayText = nextSlotClicked.time;
    }
  }

  let clickHandler = () => {};


  if (bookable) {
    if (isBetweenHover) {
      displayText = '-';
    }

    if (isLastHover && nextSlot !== undefined) {
      displayText = nextSlot.time;
    }

    clickHandler = onClick;
  }

  if (drawSpotOn === true) {
    // className = 'border-spot-on';
  }

  if (showMaster) {
    className = 'master';
  }

  if (informationBetween) {
    displayText = productName;
  }


  const classes = `${className} ${borderClass}`;


  return (
    <div className={classes} onClick={clickHandler}>
      {displayText}
    </div>
  );
};

export default Slot;



// WEBPACK FOOTER //
// ./src/components/Resource/components/Slot.jsx